import { rem } from 'polished';
import styled from 'styled-components';

import { IFormNoticeProps } from './FormNotice.types';

export const StyledWrapper = styled.span<IFormNoticeProps>`
  color: ${({ theme }) => theme.colors.cross.red};
  font-size: ${rem('12px')};
  line-height: 1.16em;
  font-weight: 400;

  ${({ isWrapped }) =>
    isWrapped &&
    `
    position: absolute;
    left: 0;
    bottom: 0;
  `};
`;
